import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";

import { BackednResponse } from "@shared/lib/types";
import { DOWNLOADS_LIST_QUERY_KEY } from "../constant";

import { IUserDownload } from "@shared/lib/types/downloads";
import { DownloadService } from "../services/Download.service";

export function useGetIUserDownloads() {
  const { data, isFetching, isError, error, isLoading } = useQuery<
    BackednResponse<IUserDownload[]>
  >({
    queryKey: [DOWNLOADS_LIST_QUERY_KEY],
    queryFn: () => DownloadService.fetchUserDownloads(),
    refetchInterval: 5000,
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    userDownloads: data?.data,
    isFetching,
    isLoading,
    isError,
  };
}
